import { useEffect, forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Container,Text,Select,Switch,Group,Alert} from '@mantine/core';
import { useForm } from "@mantine/form";
import { useDebouncedValue } from "@mantine/hooks";
import { IconInfoCircle } from "@tabler/icons-react";
import { Row,Col} from 'react-bootstrap';
import YesOrNoEnum from '../enums/YesOrNoEnum';
import BasicComputerKnowEnum from '../enums/BasicComputerKnowEnum';
import WorkingHoursEnum from '../enums/WorkingHoursEnum';
import { SaveResponses } from "../actions/ResponsesActions";
import { GetNivelEstudioPadres } from "../actions/FormDataActions"
import { stepIds} from "../enums/fieldsDataConfig";
import { useStepResponses } from '../hooks/useStepResponses';
import useFormTracking from "../hooks/useFormTracking";
import { useLocation } from 'react-router-dom';

const ExtraDataForm = forwardRef(({ stepNumber, id,queryParams }, ref) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const response = useSelector((state) => state.respuestas.steps[stepNumber]?.responses) || {};
  const dataNivelEstudio = useSelector((state) => state.datosFormulario.nivelEstudioPadres.data);
  const homologationResponse = useStepResponses(stepIds.HOMOLOGACION);

  const isListener = homologationResponse.catAlumno === 'oyente';
  const { track } = useFormTracking(stepNumber);
  const trackSelect = (fieldName) => (value) => {
    form.setFieldValue(fieldName, value);
    if (value) track('field_completed', { fieldName });
  };


  

  useEffect(() => {
    dispatch(GetNivelEstudioPadres())
  }, [dispatch])

  const getValidations = (isListener) => {
    if(isListener){
      return {}
    }else{
      const validations = {
        estudiosPadre: (value) => (value ? null : "El campo es obligatorio"),
        estudiosMadre: (value) => (value ? null : "El campo es obligatorio"),
        tieneComputadora: (value) => (value ? null : "El campo es obligatorio"),
        utilizaComputadora: (value) => (value ? null : "El campo es obligatorio"),
        tieneInternet: (value) => (value ? null : "El campo es obligatorio"),
        conocimientosInformatica: (value) => (value ? null : "El campo es obligatorio"),
      }

      if (response.trabaja) {
        validations.horasTrabajo = (value) => (value ? null : 'El campo es obligatorio');
      }

      return validations;
    }
  }
  
  
  const form=useForm({
    initialValues: {
      estudiosPadre:response.estudiosPadre || queryParams.t==='m'? '-': null,
      estudiosMadre:response.estudiosMadre ||queryParams.t==='m'? '-': null,
      trabaja:response.trabaja || false,
      horasTrabajo:response.horasTrabajo || null,
      tieneComputadora:response.tieneComputadora || queryParams.t==='m'? 'SI': null,
      utilizaComputadora:response.utilizaComputadora ||  null,
      tieneInternet:response.tieneInternet || queryParams.t==='m'? 'SI': null,
      conocimientosInformatica:response.conocimientosInformatica || null,

    },
    validate: getValidations(isListener),
  })


  const [debouncedValues] = useDebouncedValue(form.values, 300);
    
  useEffect(() => {
    dispatch(SaveResponses(id, debouncedValues));
  }, [debouncedValues, dispatch, id]);

  useImperativeHandle(ref, () => ({
    validate: () => {
      const validation = form.validate();
      if (validation.hasErrors) {
        Object.keys(validation.errors).forEach((field) =>
          track('field_error', { fieldName: field })
        );
        return false;
      }
      return true;
    },
  }));
  
  return (
    <Container size="100%" >
      {isListener ? (
        <Group justify="center">
          <Alert maw={'60%'} m={'2rem'} variant="transparent" color="#f20a61" radius="md" title="Este paso no es requerido" icon={<IconInfoCircle/>}>
            Dado que seleccionaste la opción <b>"Oyente"</b>, no es necesario que completes este formulario. Puedes proceder directamente al siguiente paso del proceso.
          </Alert>
        </Group>
      ):(
        <>
        {queryParams.t !== 'm' && (
          <>
            <Text size="xl" fw={500} mb={'xs'} c={'rgb(85, 85, 85)'}>Estudios de los padres</Text>
            <Row>
              <Col md={6}>
                <Select
                  required
                  label="Nivel máximo de estudios del padre"
                  flex={2}
                  data={dataNivelEstudio ?? []}
                  checkIconPosition='right'
                  placeholder='Seleccione una opción'
                  {...form.getInputProps("estudiosPadre")}
                onChange={trackSelect('estudiosPadre')}
                />
              </Col>
              <Col md={6}>
                <Select
                  required
                  label="Nivel máximo de estudios de la madre"
                  flex={2}
                  data={dataNivelEstudio ?? []}
                  checkIconPosition='right'
                  placeholder='Seleccione una opción'
                  {...form.getInputProps("estudiosMadre")}
                onChange={trackSelect('estudiosMadre')}
                />
              </Col>
            </Row>
          </>
        )}
          <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'}>Situación laboral</Text>
          <Row>
            <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
              <Switch
                label='¿Trabaja?'
                labelPosition="left"
                color="pink"
                size="md"
                onLabel="Si"
                offLabel="No"
                {...form.getInputProps("trabaja",{ type: 'checkbox' })}
                onChange={(e) => {
                  form.setFieldValue('trabaja', e.currentTarget.checked);
                  track('field_completed', { fieldName: 'trabaja' });
                }}
              />
            </Col>
            <Col md={6}>
              <Select
                required
                label="Cantidad de horas semanales"
                data={WorkingHoursEnum}
                disabled={!form.values.trabaja}
                checkIconPosition='right'
                placeholder='Seleccione una opción'
                {...form.getInputProps("horasTrabajo")}
                onChange={trackSelect('horasTrabajo')}
              />
            </Col>
          </Row>
          <Text size="xl" fw={500} mb={'xs'} mt={'xl'} c={'rgb(85, 85, 85)'}>Conocimientos de informática</Text>
          <Row>
            {queryParams.t !== 'm' && (
              <Col md={6}>
                <Select
                  required
                  label="¿Posee computadora en su casa?"
                  data={YesOrNoEnum}
                  checkIconPosition='right'
                  placeholder='Seleccione una opción'
                  {...form.getInputProps("tieneComputadora")}
                  onChange={trackSelect('tieneComputadora')}
                />
              </Col>
            )}
            {queryParams.t !== 'm' && (
              <Col md={6}>
                <Select
                  required
                  label="¿Posee conexión a Internet en su domicilio?"
                  flex={2}
                  data={YesOrNoEnum}
                  checkIconPosition='right'
                  placeholder='Seleccione una opción'
                  {...form.getInputProps("tieneInternet")}
                  onChange={trackSelect('tieneInternet')}
                />
              </Col>
            )}
          </Row>
            <Row>
            <Col md={6}>
              <Select
                required
                label="¿Utiliza la computadora habitualmente?"
                flex={2}
                data={YesOrNoEnum}
                checkIconPosition='right'
                placeholder='Seleccione una opción'
                {...form.getInputProps("utilizaComputadora")}
                onChange={trackSelect('utilizaComputadora')}
              />
            </Col>

          <Col md={6}>
              <Select
                required
                label="¿Tiene conocimientos básicos de Informática?"
                flex={2}
                data={BasicComputerKnowEnum}
                checkIconPosition='right'
                placeholder='Seleccione una opción'
                {...form.getInputProps("conocimientosInformatica")}
                onChange={trackSelect('conocimientosInformatica')}
              />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
});

export default ExtraDataForm;
